export default "__VITE_ASSET__05db68f8__"